import {Avatar, Chip, Tooltip} from '@mui/material';
import React from 'react';
import {useSelector} from 'react-redux';
import config from 'src/config';
import {getHistory} from 'src/modules/store';
import ubicacionSelectors from 'src/modules/ubicacion/ubicacionSelectors';

function ChipPlanificacionView(props) {
  const {record, type, size} = props;

  const hasPermissionToRead = useSelector(ubicacionSelectors.selectPermissionToRead);

  const redirectTo = () => {
    if (hasPermissionToRead) {
      getHistory().push(`/planificacion/` + record.id);
    }
  };

  const photoUrl = record?.fotosAdjuntas
    ? config.backendUrl + '/file/download?privateUrl=' + record?.fotosAdjuntas[0]?.privateUrl
    : '';

  const label = record?.nombre;

  if (type === 'chip') {
    return (
      <Tooltip followCursor title={label}>
        <Chip
          avatar={photoUrl ? <Avatar src={photoUrl || ''} alt={label} /> : undefined}
          label={label}
          onClick={() => console.log('onClick')}
          variant="outlined"
          color="primary"
        />
      </Tooltip>
    );
  }

  if (type === 'avatar') {
    return (
      <Tooltip followCursor title={label}>
        <Avatar onClick={() => console.log('onClick')} style={{width: size, height: size}} src={photoUrl || ''} alt={label} />
      </Tooltip>
    );
  }

  return <div></div>;
}

export default ChipPlanificacionView;
